<template>
  <div>
    <b-modal @hide="assignedModalClose" ref="assignedModal" :title="$t('使用可能人員設定')" size="xl">
      <b-container fluid>
        <div class="search inner_modal">
          <h2 class="title">{{ $t("検索条件") }}</h2>
          <div class="content">
            <div class="d-flex flex-row">
              <div class="m-3 d-flex flex-row align-items-center justify-content-start form-group">
                <label for="search-status" class="label">{{ $t("工場") }}:&nbsp;</label>
                <select class="custom-select select" id="id_factory" v-model="form.site">
                  <option selected></option>
                  <template v-for="(item ,index) in mixinSpacesListDisplay('site')" :keyed="`site-${index}`">
                    <option :value="item.id" :key="`site-${index}`">{{ item.name }}</option>
                  </template>
                </select>
                <label for="search-status" class="label ml-3">{{ $t("部署") }}:&nbsp;</label>
                <select name="factory" class="input form-control" id="id_department" v-model="form.dep">
                  <option value=""></option>
                  <template v-for="(item ,index) in mixinSpacesListDisplay('dep')" :keyed="`dep-${index}`">
                    <option :value="item.id" :key="`dep-${index}`">{{ item.name }}</option>
                  </template>
                </select>
              </div>
            </div>
          </div>
          <div class="button">
            <button class="btn btn-info" @click="searchUsers()">
              {{ $t("検索") }}
            </button>
          </div>
        </div>

        <div class="search inner_modal search_result mt-4">
          <h2 class="title">{{ $t("検索結果") }}</h2>
          <div class="content">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <td>&nbsp;</td>
                  <td>{{ $t("工場") }}</td>
                  <td>{{ $t("部署") }}</td>
                  <td>{{ $t("氏名") }}</td>
                  <td>{{ $t("ログインID") }}</td>
                  <!-- <td>{{ $t("時間単価") }}</td> -->
                </tr>
              </thead>
              <tbody>
                <template v-if="!load && users.length">
                  <tr v-for="(item, index) in users" :key="index">
                    <td><input type="checkbox" v-model="item.check"></td>
                    <td>{{ mixinSpacesDisplay(item.site) }}</td>
                    <td>{{ mixinSpacesDisplay(item.dep) }}</td>
                    <td>{{ item.name }}</td>
                    <td>{{ item.loginId }}</td>
                    <!-- <td>{{ item.hourPrice | mixinCommaDisplay }}</td> -->
                  </tr>
                </template>
                <template v-else-if="!load && users.length === 0">
                  <tr>
                    <td rowspan="2" colspan="99" class="text-center">
                      {{ $t("ノーデータメッセージ") }}
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td colspan="12">
                      <div class="d-flex justify-content-center m-5" v-if="load">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
        </div>
      </b-container>
      <template v-slot:modal-footer>
        <p class="text-danger text-center" v-if="create.error">{{ create.error }}</p>
        <button
          type="button"
          class="btn btn-light"
          @click="assignedModalClose()"
          v-if="!create.confirm"
          :disabled="create.registering"
        >{{ $t("キャンセル") }}</button>
        <button
          type="button"
          class="btn btn-success mr-4"
          @click="checkAffectedProcesses()"
          :disabled="create.registering"
        >
          <div
            class="d-flex justify-content-center align-items-center mr-3"
            v-if="create.registering"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </div>
          {{ $t("登録") }}
        </button>
      </template>
    </b-modal>

    <b-modal @hide="modalConfirmationClose" ref="unassignedConfirmation" :title="$t('担当者設定変更')" size="l">
      <b-container fluid>
        <div class="inner mt-4">
          <div class="content" style="white-space: pre-line">
            {{ $t('process.user.change.confirmation') }}
          </div>
        </div>
      </b-container>
      <template v-slot:modal-footer>
        <p class="text-danger text-center"></p>
        <div class="d-flex justify-content-center align-items-center mt-4 mb-4 w-100">
          <button
            type="button"
            class="btn btn-light"
            @click="modalConfirmationClose()"
          >{{ $t("キャンセル") }}</button>
          <button
            type="button"
            class="btn btn-success mr-3 d-flex align-items-center justify-content-center"
            @click="createRegister()"
          >{{ $t("OK") }}</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const defaultCreate = {
  load: false,
  form: {
    id: null,
    name: '',
    code: '',
    division: '',
    isOperativeBreakTime: true,
    isOperativeNonRegularTime: false,
    site: null,
    dep: null,
    hourPrice: null,
    iot1: '',
    iot2: '',
    iot3: '',
    iot4: '',
    iot5: '',
    processKindId: null,
    userIds: [],
    sort: null,
    displayColor: '',
  },
  list: [],
  registration: false,
  error: '',
}
export default {
  data() {
    return {
      form: {
        site: null,
        dep: null,
      },
      create: this.mixin_deepcopy(defaultCreate),
      processKinds: [],
      master: {},
      load: false,
      users: [],
    }
  },
  methods: {
    // モーダルを開いたときの処理
    modalOpen(item, processKinds, master) {
      const copy = this.mixin_deepcopy(item)
      if (copy.id) {
        this.create.form = copy
      }
      this.processKinds = processKinds // 工程区分
      this.master = master // マスター
      this.$refs.assignedModal.show()
      this.searchUsers()
    },
    assignedModalClose() {
      this.create = {
        load: false,
        list: [],
        registration: false,
        error: '',
        registering: false,
      }
      this.form.site = null
      this.form.dep = null
      this.$refs.assignedModal.hide()
    },
    modalConfirmationClose() {
      this.create.registering = false
      this.$refs.unassignedConfirmation.hide()
    },
    async searchUsers() {
      this.load = true
      try {
        let params = {}
        if (this.form.site) params.site = this.form.site
        if (this.form.dep) params.dep = this.form.dep
        const res = await this.$axios.get(`${this.$appConfig.CommonApiUrl}/users`, {
          headers: {
            'Authorization': this.authorization ? this.authorization : null,
          },
          params: params,
        })
        this.users = Array.from(res.data).map((user) =>{
          user.check = (user.processIds.indexOf(this.create.form.id) !== -1)
          return user
        })
        this.load = false
      } catch (err) {
        this.$toasted.show(this.$t('データ取得エラーメッセージ'))
      }
    },
    async checkAffectedProcesses() {
      this.create.registering = true
      const params = this.initParams()
      let method = 'put'
      try {
        let res = await this.$axios({
          method: method,
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/process/precheck-unassign-pic`,
          data: params,
        })

        if (!res.data['isAffected']) {
          this.createRegister()
          return
        }
      } catch (err) {
        console.log(err)
        this.$toasted.show(this.$t('データ登録エラーメッセージ'))
        return
      }

      this.$refs.unassignedConfirmation.show()
    },

    initParams() {
      const params = {}
      params['id'] = this.create.form.id
      params['code'] = this.create.form.code || ''
      params['name'] = this.create.form.name
      params['division'] = this.create.form.division
      params['isOperativeBreakTime'] = this.create.form.isOperativeBreakTime
      params['isOperativeNonRegularTime'] = this.create.form.isOperativeNonRegularTime
      params['site'] = this.create.form.site || null
      params['dep'] = this.create.form.dep || null
      params['hourPrice'] = this.create.form.hourPrice || (this.create.form.hourPrice === 0 ? 0 : null)
      params['iot1'] = this.create.form.iot1 || ''
      params['iot2'] = this.create.form.iot2 || ''
      params['iot3'] = this.create.form.iot3 || ''
      params['iot4'] = this.create.form.iot4 || ''
      params['iot5'] = this.create.form.iot5 || ''
      params['processKindId'] = this.create.form.processKindId
      params['sort'] = this.create.form.sort || (this.create.form.sort === 0 ? 0 : null)
      params['displayColor'] = this.create.form.displayColor || ''
      // ユーザーID取得
      const userIds = Array.from(this.users).filter((user) => {
        return user.check
      }).map(user => user.id)
      // パラメータに登録
      params.userIds = userIds

      return params
    },
    async createRegister() {
      this.modalConfirmationClose()
      this.create.registering = true
      const params = this.initParams()

      try {
        await this.$axios({
          method: 'put',
          headers: {
            Authorization: this.authorization ? this.authorization : null,
          },
          url: `${this.$appConfig.CommonApiUrl}/process`,
          data: params,
        })
        this.$toasted.success(this.$t('データ登録完了メッセージ'))
        this.assignedModalClose()
        this.$emit('registed')
      } catch (err) {
        this.$toasted.show('データ登録エラーメッセージ')
      } finally {
        this.create.registering = false
      }
    },
  },
  computed: {
    ...mapGetters({
      authorization: 'auth/authorization',
    }),
  },
}
</script>

<style lang="scss" scoped>
.search_result{
  .content{
    padding: 0;
  }
}
</style>
